"use strict";

import angular from "angular";

import template from "./card-accounting.component.html";
import "./themes/card-accounting.component-dark.scss";
import "./themes/card-accounting.component.scss";

import _ from "lodash";
class CardAccountingComponent {
    constructor() {
        this.list = [];
        this.card = {};
    }

    $onInit() {
        this.card = this.configCard.pages
            ? this.configCard.pages[this.configCard.currentPage]
            : this.configCard;
        this.list = [].concat(_.get(this.card, "totals"));
    }

    onChangePage() {
        if (!this.configCard.pages) return;
        if (
            this.configCard.currentPage + 1 ===
            _.get(this.configCard, "pages.length")
        )
            this.configCard.currentPage = -1;

        this.configCard.currentPage += 1;

        this.card = this.configCard.pages[this.configCard.currentPage];
    }
}

CardAccountingComponent.$inject = [];

const name = "cardAccountingComponent";
const def = {
    controller: CardAccountingComponent,
    bindings: {
        configCard: "<",
        onClickOption: "&"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
